import ctl from "@netlify/classnames-template-literals";

export const loader = ctl(`
  flex  
  w-full
  flex-col
  items-center
  justify-center
`);

export const loaderBorder = ctl(`
  w-[200px]
  h-[200px]
  md:w-[232px]
  md:h-[232px]
  rounded-full
  bg-gradient-ellipse-tl
  from-purple-650
  via-purple-650
  via-bg-transparent
  to-bg-transparent
  relative
  flex
  items-center
  justify-center
`);

export const loaderBackground = ctl(`
  w-[198px]
  h-[198px]
  md:w-[230px]
  md:h-[230px]
  rounded-full
  bg-purple-950
  flex
  items-center
  justify-center
  backdrop-blur-[2px]
`);
